import { render, staticRenderFns } from "./ClubDetail.vue?vue&type=template&id=28efc6db&scoped=true"
import script from "./ClubDetail.vue?vue&type=script&lang=js"
export * from "./ClubDetail.vue?vue&type=script&lang=js"
import style0 from "./ClubDetail.vue?vue&type=style&index=0&id=28efc6db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Vue/course_selecttion_v3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28efc6db",
  null
  
)

export default component.exports